import React from "react";
import OrderForm from "../Components/OrderForm";

export default function AddPublicOrder() {
  return <OrderForm variant="public" />;
}
